import React, { useCallback, useState } from 'react';
import Icon from "@scentregroup/ui/components/icon";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function SearchModal(props) {
  const {
    onSubmit,
    onClickClose,
    placeholder = 'Search stores, news, events and more'
  } = props;
  const {
    0: query,
    1: setQuery
  } = useState('');

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      // Trigger blur event to dismiss the Keyboard when user clicks Search in iOS.
      if (!window.document.activeElement) {
        return;
      }

      ;
      window.document.activeElement.blur();
    }
  };

  const onSubmitWrapper = useCallback(e => {
    onSubmit(e, query);
  }, [onSubmit, query]);
  return /*#__PURE__*/_jsxs("div", {
    className: style.searchModalInputSection,
    "data-id": "search_search-modal_SearchModal_div",
    children: [/*#__PURE__*/_jsx("button", {
      "aria-label": "Close search",
      className: style.closeButton,
      onClick: onClickClose,
      "data-id": "search_search-modal_SearchModal_div_button",
      children: /*#__PURE__*/_jsx(Icon, {
        type: "cross",
        "data-id": "search_search-modal_SearchModal_button_Icon"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style.inputbar,
      onSubmit: onSubmitWrapper,
      "data-id": "search_search-modal_SearchModal_div_div",
      children: /*#__PURE__*/_jsxs("form", {
        action: "#",
        onSubmit: e => e.preventDefault(),
        "data-id": "search_search-modal_SearchModal_div_form",
        children: [/*#__PURE__*/_jsx("input", {
          /* Disabling no-autofocus to convert legacy JS file to TypeScript */
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus: true,
          id: "search-textfield",
          type: "search",
          className: style.textfield,
          autoCapitalize: "off",
          spellCheck: "false",
          autoCorrect: "off",
          autoComplete: "off",
          placeholder: placeholder,
          value: query,
          onChange: event => setQuery(event.target.value),
          onKeyPress: handleKeyPress,
          "data-id": "search_search-modal_SearchModal_form_input"
        }), /*#__PURE__*/_jsx("label", {
          htmlFor: "search-textfield",
          "data-id": "search_search-modal_SearchModal_form_label",
          children: /*#__PURE__*/_jsx(Icon, {
            type: "search",
            className: style.searchIcon,
            "data-id": "search_search-modal_SearchModal_label_Icon"
          })
        }), query ? /*#__PURE__*/_jsx("button", {
          "aria-label": "Clear search text",
          className: style.clearButton,
          type: "button",
          onClick: () => setQuery(''),
          "data-id": "search_search-modal_SearchModal_button",
          children: /*#__PURE__*/_jsx(Icon, {
            type: "clear",
            size: "small",
            className: style.clearIcon,
            "data-id": "search_search-modal_SearchModal_button_Icon"
          })
        }) : null, /*#__PURE__*/_jsx("button", {
          className: style.searchButton,
          "aria-label": "search button",
          "data-id": "search_search-modal_SearchModal_form_button",
          children: "SEARCH"
        })]
      })
    })]
  });
}

export default SearchModal;